export var INTAKE_SITE_STAGING = 'datad0g.com';
export var INTAKE_SITE_US1 = 'datadoghq.com';
export var INTAKE_SITE_EU1 = 'datadoghq.eu';
export var INTAKE_SITE_AP1 = 'ap1.datadoghq.com';
export var INTAKE_SITE_US1_FED = 'ddog-gov.com';
//# sourceMappingURL=intakeSites.js.map